<template>
  <splash></splash>
  <div class="container mt-4" dir="rtl">

    <sidebar></sidebar>
    <div style="    position: absolute;
    right: 28vw;
    width: 51vw; height: auto;" class="card-panel-main col-lg-9 mb-5">
      <div class="card card-body card-panel-box border-0" style="    margin: 1vw .9vw;">
        <div class="col-lg-12">
          <div class="card card-body card-panel-box border-0">
            <div class="row d-flex justify-content-start">
              <div class="d-flex justify-content-between">
                <h2 style="font-size: 1.2vw !important;width: 14vw;">لیست شرکت های تابعه</h2>

                <p style="text-align:-webkit-left">
                  <router-link v-if="isBackToUserList" to="/pishkhan/list/user_self"
                               class="btn btn-primary btn-back mt-2">
                    تعریف کاربران
                  </router-link>
                  <button @click="$router.go(-2)" style="width: 5vw; margin-top: 0.5vw;"
                          class="btn btn-primary btn-back">
                    برگشت
                  </button>
                  <router-link
  v-if="!$cookies.isKey('is_process_manager') && $router.options.history.state.back === '/process/map'"
  to="/process/map_self"
  class="btn btn-primary btn-back mt-2" style="width: 9vw;"
>
 تعریف فرآیندهای پایه
</router-link>

                  <router-link v-if="$router.options.history.state.back === '/job/evaluation'"
                               to="/job/evaluation/by/self" class="btn btn-primary btn-back mt-2">
                    تعریف کارسنجی
                  </router-link>
                </p>
              </div>

              <div class="d-flex justify-content-between mb-2">
                <input v-model="searchUser" type="text" class="form-control" style="width: 20vw;"
                       placeholder="جستجو بر اساس نام شرکت  ...">
                <button v-if="isBackToUserList" @click="addNewMethod" class="btn btn-primary btn-submit-1">افزودن</button>
              </div>

              <hr>
            </div>
            <div class="table-responsive mt-3">
              <center v-if="!all_users.length">
                شرکتی یافت نشد
              </center>
              <div style="overflow-y: auto; height: 50vw;" :style="all_users.length < 19 ? 'height: auto;' : ''">

                <table v-if="all_users.length" class="table table-striped">
                  <thead>
                  <tr>
                    <th style="width: 1vw;">ردیف</th>
                    <th>نام</th>
                    <th style="width: 17vw;"> مشاهده</th>
                    <template v-if="isBackToUserList">
                      <th style="width: 5vw;">عملیات</th>
                      <th style="width:7vw;">پست سازمانی</th>
                      <th style="width: 5vw;">فرآیند ها</th>
                      <th style="width: 5vw;">فعالیت ها</th>
                    </template>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(item, index) in filteredItems" :key="item.id">
                    <td scope="row">{{ index + 1 }}
                      <i v-if="check_dot(item.id) && !check_dot_success(item.id)" class="custom-marker-dot bg-danger"
                         style="transform: translateX(-4.2vw) translateY(-3vw); scale: 0.4;"></i>

                         <i v-if="check_dot_success(item.id)" class="custom-marker-dot "
                         style="transform: translateX(-4.2vw) translateY(-3vw); scale: 0.4;background: #3fb918;"></i>

                    </td>
                    <td>
                      {{ item['name'] }}
                    </td>
                    <td>

                      <router-link v-if="isBackToUserList" :to="`/pishkhan/list/user/by/${item.id}/${item.name}`"
                                   class=" w-100 btn btn-primary btn-submit-1">مشاهده کاربران
                      </router-link>
                      <router-link v-if="$router.options.history.state.back === '/pishkhan/Organization/list'"
                                   :to="`/pishkhan/Organization/list/by/${item.id}/${item.name}`"
                                   class="w-100 btn btn-primary btn-submit-1">مشاهده پست سازمانی
                      </router-link>
                      <router-link v-if="$router.options.history.state.back === '/process/map'"
                                   :to="`/process/map/by/${item.id}/${item.name}`"
                                   class="w-100 btn btn-primary btn-submit-1">مشاهده نقشه فرآیندی
                      </router-link>
                      <router-link v-if="$router.options.history.state.back === '/process/id'"
                                   :to="`/process/id/by/${item.id}/${item.name}`"
                                   class="w-100 btn btn-primary btn-submit-1">مشاهده شناسنامه فرآیند ها
                      </router-link>
                      <router-link v-if="$router.options.history.state.back === '/Process/documentation/management'"
                                   :to="`/Process/documentation/management/by/${item.id}/${item.name}`"
                                   class="w-100 btn btn-primary btn-submit-1">مدیریت مستندات فرآیندی
                      </router-link>
                      <router-link v-if="$router.options.history.state.back === '/beneficiary/map'"
                                   :to="`/beneficiary/map/by/${item.id}/${item.name}`"
                                   class="w-100 btn btn-primary btn-submit-1">نقشه ذی نفعان
                      </router-link>
                      <router-link
                          v-if="$router.options.history.state.back === '/Financial_management_and_productivity/definitions'"
                          :to="`/Financial_management_and_productivity/definitions/by/${item.id}}/${item.name}`"
                          class="w-100 btn btn-primary btn-submit-1">مالی و بهره وری/تعاریف اولیه
                      </router-link>
                      <router-link
                          v-if="$router.options.history.state.back === '/Financial_management_and_productivity/FaceDefinitionFinancialSituation'"
                          :to="`/Financial_management_and_productivity/FaceDefinitionFinancialSituation/by/${item.id}/${item.name}`"
                          class="w-100 btn btn-primary btn-submit-1">مالی و بهره وری/ساختار صورت وضعیت مالی
                      </router-link>
                      <router-link
                          v-if="$router.options.history.state.back === '/Financial_management_and_productivity/ProfitAndLossStructure'"
                          :to="`/Financial_management_and_productivity/ProfitAndLossStructure/by/${item.id}/${item.name}`"
                          class="w-100 btn btn-primary btn-submit-1">مالی و بهره وری/ساختار صورت سود و زیان
                      </router-link>
                      <router-link
                          v-if="$router.options.history.state.back === '/Financial_management_and_productivity/TheStructureOfTheCashFlowStatement'"
                          :to="`/Financial_management_and_productivity/TheStructureOfTheCashFlowStatement/by/${item.id}/${item.name}`"
                          class="w-100 btn btn-primary btn-submit-1">مالی و بهره وری/ صورت جریان وجوه نقد
                      </router-link>
                      <router-link
                          v-if="$router.options.history.state.back === '/Financial_management_and_productivity/DefinitionOfOutput'"
                          :to="`/Financial_management_and_productivity/DefinitionOfOutput/by/${item.id}/${item.name}`"
                          class="w-100 btn btn-primary btn-submit-1">مالی و بهره وری/ تعریف ستانده
                      </router-link>
                      <router-link
                          v-if="$router.options.history.state.back === '/Financial_management_and_productivity/DefinitionOfConsequence' || $router.options.history.state.back === '/Financial_management_and_productivity/IntermediateOutcome'"
                          :to="`/Financial_management_and_productivity/DefinitionOfConsequence/by/${item.id}/${item.name}`"
                          class="w-100 btn btn-primary btn-submit-1">مالی و بهره وری/ تعریف پیامد
                      </router-link>
                      <router-link
                          v-if="$router.options.history.state.back === '/Financial_management_and_productivity/DefinitionOfEffect'"
                          :to="`/Financial_management_and_productivity/DefinitionOfEffect/by/${item.id}/${item.name}`"
                          class="w-100 btn btn-primary btn-submit-1">مالی و بهره وری/ تعریف اثر
                      </router-link>
                      <router-link
                          v-if="$router.options.history.state.back === '/Financial_management_and_productivity/functional_information'"
                          :to="`/Financial_management_and_productivity/functional_information/by/${item.id}/${item.name}`"
                          class="w-100 btn btn-primary btn-submit-1">مالی و بهره وری/ درج اطلاعات عملکردی
                      </router-link>
                      <router-link
                          v-if="$router.options.history.state.back === '/Financial_management_and_productivity/budget_information'"
                          :to="`/Financial_management_and_productivity/budget_information/by/${item.id}/${item.name}`"
                          class="w-100 btn btn-primary btn-submit-1">مالی و بهره وری/ درج اطلاعات بودجه ای
                      </router-link>
                      <router-link
                          v-if="$router.options.history.state.back === '/Financial_management_and_productivity/Determining_the_mission'"
                          :to="`/Financial_management_and_productivity/Determining_the_mission/by/${item.id}/${item.name}`"
                          class="w-100 btn btn-primary btn-submit-1">مالی و بهره وری/ تعیین ماموریت
                      </router-link>
                      <router-link
                          v-if="$router.options.history.state.back === '/problem_analysis/Problem_identification'"
                          :to="`/problem_analysis/Problem_identification/by/${item.id}/${item.name}`"
                          class="w-100 btn btn-primary btn-submit-1">مسئله شناسی/ شناسایی مسئله
                      </router-link>
                      <router-link v-if="$router.options.history.state.back === '/problem_analysis/Prioritizing_issue'"
                                   :to="`/problem_analysis/Prioritizing_issue/by/${item.id}/${item.name}`"
                                   class="w-100 btn btn-primary btn-submit-1">مسئله شناسی/ اولویت بندی مسائل
                      </router-link>
                      <router-link
                          v-if="$router.options.history.state.back === '/problem_analysis/The_root_causes_of_the_problem'"
                          :to="`/problem_analysis/The_root_causes_of_the_problem/by/${item.id}/${item.name}`"
                          class="w-100 btn btn-primary btn-submit-1">مسئله شناسی/ ریشه علل مسئله
                      </router-link>
                      <router-link
                          v-if="$router.options.history.state.back === '/problem_analysis/Definition_of_basic_measures'"
                          :to="`/problem_analysis/Definition_of_basic_measures/by/${item.id}/${item.name}`"
                          class="w-100 btn btn-primary btn-submit-1">مسئله شناسی/ تعریف اقدامات اساسی
                      </router-link>
                      <router-link
                          v-if="$router.options.history.state.back === '/problem_analysis/device_monitoring_and_care'"
                          :to="`/problem_analysis/device_monitoring_and_care/by/${item.id}/${item.name}`"
                          class="w-100 btn btn-primary btn-submit-1">مسئله شناسی/ پایش و مراقبت دستگاه
                      </router-link>
                      <router-link v-if="$router.options.history.state.back === '/Impact_Assessment'"
                                   :to="`/Impact_Assessment/by/${item.id}/${item.name}`"
                                   class="w-100 btn btn-primary btn-submit-1">مسئله شناسی/ سنجش اثرات
                      </router-link>
                      <router-link v-if="$router.options.history.state.back === '/job/evaluation'"
                                   :to="`/job/evaluation/by/${item.id}/${item.name}`"
                                   class="w-100 btn btn-primary btn-submit-1">مدیریت فرآیند ها / کارسنجی
                      </router-link>
                      <router-link v-if="$router.options.history.state.back === '/executive_elements'"
                                   :to="`/executive_elements/by/${item.id}/${item.name}`"
                                   class="w-100 btn btn-primary btn-submit-1">ارکان اجرایی
                      </router-link>
                      <router-link v-if="$router.options.history.state.back === '/RolesAndResponsibilities'"
                                   :to="`/RolesAndResponsibilities/by/${item.id}/${item.name}`"
                                   class="w-100 btn btn-primary btn-submit-1" style="font-size: 0.7vw">مدیریت فرآیند ها
                        / نقش ها و مسئولیت ها در فرآیند
                      </router-link>
                      <router-link v-if="$router.options.history.state.back === '/strategicManagement/basic_defined'"
                                   :to="`/strategicManagement/basic_defined_strategic_management_mother/${item.id}/${item.name}`"
                                   class="w-100 btn btn-primary btn-submit-1" style="font-size: 0.7vw">مدیریت
                        استراتژیک/تعاریف پایه/ واحدهای کسب و کار
                      </router-link>
                      <router-link
                          v-if="$router.options.history.state.back === '/Matrix_Connections'"
                          :to="`/Matrix_Connections/by/${item.id}/${item.name}`"
                          class="w-100 btn btn-primary btn-submit-1" style="font-size: 0.7vw">مدیریت فرآیند ها / ماتریس
                        ارتباطات
                      </router-link>

                      <router-link
                          v-if="$router.options.history.state.back === '/productivity_improvement_program'"
                          :to="`/productivity_improvement_program/by/${item.id}/${item.name}`"
                          class="w-100 btn btn-primary btn-submit-1" style="font-size: 0.7vw"> 
                        برنامه ارتقای بهره وری
                      </router-link>
                    </td>

                    <template v-if="isBackToUserList">
                      <td>
                        <a @click.prevent="edit(item['id'])" href="#"><img class="table-edit-img"
                                                                           src="../../../assets/img/pen.svg"
                                                                           alt="edit"></a>
                        &nbsp;
                        <a @click.prevent="deleteItem(item['id'])" href="#"><img class="table-delete-img mr-1"
                                                                                 src="../../../assets/img/delete.svg"
                                                                                 alt="delete"></a>
                      </td>
                      <td>
                        <button style="width: 7vw;" class="btn btn-primary btn-add-org-post"
                                :style="!item.complate_organ ? 'background: #7FFFD4' : ''">
                          <span v-if="item.complate_organ">منتشر شده</span>
                          <span v-else @click.prevent="submitCloneOrganMethod(item.id)">انتشار</span>
                        </button>
                      </td>
                      <td>
                        <div v-if="!item.complate_organ">--</div>
                        <div v-else>
                          <button style="width: 5vw;" class="btn btn-primary btn-add-org-post"
                                  :style="!item.complate_process ? 'background: #7FFFD4' : ''">
                          <span v-if="!item.complate_process"
                                @click.prevent="submitCloneProcessMethod(item.id)">انتشار</span>
                            <span v-else>منتشر شده</span>
                          </button>
                        </div>

                      </td>
                      <td>
                        <div v-if="!item.complate_organ">--</div>
                        <div v-else-if="!item.complate_process">--</div>
                        <div v-else>
                          <button style="width: 5vw;" class="btn btn-primary btn-add-org-post"
                                  :style="!item.complate_task ? 'background: #7FFFD4' : ''">
                            <span v-if="!item.complate_task"
                                  @click.prevent="submitCloneTaskMethod(item.id)">انتشار</span>
                            <span v-else>منتشر شده</span>
                          </button>
                        </div>

                      </td>
                    </template>
                  </tr>

                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div dir="rtl" class="modal__error slide-top" v-show="addNew || editModal"
       style="z-index: 999999999999999; top: 40%; width: 30vw;">
    <div>
      <p v-if="!editModal">افزودن جدید</p>
      <p v-else>ویرایش </p>
      <p v-if="!editModal" @click="addNew=!addNew">❌</p>
      <p v-else @click="editModal=!editModal">❌</p>
    </div>
    <div style="overflow-y: scroll; overflow-x: hidden; height: 19vw;">

      <div class="d-flex flex-row  " style=" width: 25vw;">
        <div class="w-100">
          <label title="نام شرکت باید فرمت فارسی باشد">
            <span class="required">نام شرکت</span>
            <span>❔</span>
          </label>
          <input v-model="company_name" type="text" class="form-control w-100">
        </div>

      </div>
      <div class="d-flex flex-row  " style="margin-left: 1vw">
        <div class="mx-3">
          <label class="required" title="نام رئیس کمیته باید فرمت فارسی باشد">نام رئیس کمیته
          </label>
          <input v-model="first_name" type="text" class="form-control">
        </div>
        <div class="mx-3">
          <label class="required" title=" نام خانوادگی رئیس کمیته باید فرمت فارسی باشد"> نام خانوادگی رئیس کمیته
          </label>
          <input v-model="last_name" type="text" class="form-control">
        </div>
      </div>
      <div class="d-flex flex-row mt-2" style="transform: translateX(0vw)">
        <div class="mx-3">
          <label class="required">کد پرسنلی</label>
          <input v-model="personalCode" type="number" class="form-control">
        </div>
        <div class="mx-3" style="    width: 12vw !important;">
          <label class="required">کدملی</label>
          <input v-model="nationalCode" type="text" class="form-control">
        </div>
        
      </div>
      <div  class="d-flex flex-row my-2" style="display: none !important;">
        <div class="mx-3" style="width: 12vw;">
          <label >فایل امضا
          </label>
          <input type="file" class="form-control d-block" id="file">
        </div>
        <div class="mx-3">
          <label>شماره همراه
          </label>
          <input v-model="phone" type="text" class="form-control">
        </div>
      </div>
      <div class="d-flex flex-row my-2" style="display: none !important;">
        <div class=" mb-3">
          <label class="form-label">تحصیلات</label>
          <input v-model="uni_dredge" class="form-control" type="text" name="" required>
        </div>
        <div class=" mx-3">
          <label class="form-label">سابقه کار</label>
          <input v-model="work_history" class="form-control" type="text" name="" required>
        </div>
      </div>
      <div class="row p-3" style="display: none !important;">
        <div class="mb-3" style="width: 26vw;">
          <label class="form-label">دوره آموزشی چرخه مدیریت بهره‌وری را با موفقیت پشت‌سر گذاشته‌اند؟</label>
          <select class="form-select" v-model="course_management">
            <option value="" disabled selected>انتخاب کنید</option>
            <option value="1">بله</option>
            <option value="0">خیر</option>
          </select>
        </div>
      </div>

      <h4 style="font-size: 1vw !important; display: none !important;" >تکمیل اطلاعات دوره مقدماتی</h4>
      <div class="row p-2" style="width: 26vw; display: none !important;" >
        <div class="col-lg-4 mb-3">
          <label class="form-label">تاریخ </label>
          <Vue3PersianDatetimePicker v-model="intro_date"></Vue3PersianDatetimePicker>
        </div>
        <div class="col-lg-4 mb-3">
          <label class="form-label">مکان </label>
          <textarea v-model="intro_location" class="form-control" id="" cols="30" rows="10"></textarea>
        </div>
        <div class="col-lg-4 mb-3">
          <label class="form-label">گواهینامه </label>
          <input v-model="intro_certificate" class="form-control" type="text" name="" required>
        </div>
      </div>

      <h4 style="font-size: 1vw !important display: none !important;display: none !important;" class="mt-3">تکمیل اطلاعات دوره تکمیلی</h4>
      <div class="row p-2" style="width: 26vw;display: none !important;">
        <div class="col-lg-4 mb-3">
          <label class="form-label">تاریخ </label>
          <Vue3PersianDatetimePicker v-model="supplementary_date"></Vue3PersianDatetimePicker>
        </div>
        <div class="col-lg-4 mb-3">
          <label class="form-label">مکان </label>
          <textarea v-model="supplementary_location" class="form-control" id="" cols="30" rows="10"></textarea>
        </div>
        <div class="col-lg-4 mb-3">
          <label class="form-label">گواهینامه </label>
          <input v-model="supplementary_certificate" class="form-control" type="text" name="" required>
        </div>
      </div>

      <div class="mx-3 " style="width: 24vw;" v-if="false">
        <label>
          کپی کردن از شرکت های زیر
        </label>
        <select v-model="copy_id" class="form-select">
          <option value="" disabled selected>انتخاب کنید</option>
          <option v-for="item in all_users" :value="item.id">{{ item.name }}</option>
        </select>
      </div>

      <div class="form-buttons row d-flex justify-content-around mt-5 mb-3" style="width: 20vw;">
        <button v-if="!editModal" @click="addNew=!addNew" class="btn btn-primary btn-back" type="submit">برگشت</button>
        <button v-else @click="editModal=!editModal" class="btn btn-primary btn-back" type="submit">برگشت</button>
        <button v-if="!editModal" class="btn btn-primary btn-approve" @click="store">تایید</button>
        <button v-else class="btn btn-primary btn-approve" @click="update(id)">ویرایش</button>
      </div>
    </div>
  </div>
  <div dir="rtl" class="modal__error slide-top" v-show="deleteModal" style="z-index: 999999999999999">
    <div>
      <p>حذف</p>
      <p @click="deleteModal=!deleteModal">❌</p>
    </div>
    <div>
      <p>آیا میخواهید حذف کنید!</p>

      <div class="form-buttons row d-flex justify-content-around mt-5 mb-3" style="width: 20vw;">
        <button @click="deleteModal=!deleteModal" class="btn btn-primary btn-back" type="submit">برگشت</button>
        <button class="btn btn-primary btn-approve" @click="deleteItemForm(id)">تایید</button>
      </div>
    </div>
  </div>
  <div dir="rtl" class="modal__error slide-top" v-show="cloneAllModal" style="z-index: 999999999999999">
    <div>
      <p>اطلاعیه</p>
      <p @click="cloneAllModal=!cloneAllModal">❌</p>
    </div>
    <div>
      <p style="background-color:#fff; padding: 1vw; text-align: right; border-radius: 1vw;">آیا میخواهید موارد در تمامی
        شرکت های زیرمجموعه ایجاد شود؟</p>
      <button v-if="!is_load" @click="submitCloneAll">تایید</button>
      <button style="width: 28vw !important;" disabled v-else>در حال کپی کردن فرآیند ها و فعالیت ها در شرکت های
        تابعه...
      </button>
    </div>
  </div>

  <div dir="rtl" class="modal__error slide-top" style="z-index: 999999999999999" v-show="submitCloneOrganModal">
    <div>
      <p>اطلاعیه</p>
      <p @click="submitCloneOrganModal=!submitCloneOrganModal">❌</p>
    </div>
    <div>
      <p style="background-color:#fff; padding: 1vw; text-align: right; border-radius: 1vw;">آیا میخواهید پست های
        سازمانی در شرکت تابعه ایجاد شود؟</p>
      <button v-if="!is_load" @click="submitCloneOrgan">تایید</button>
      <button style="width: 28vw !important;" disabled v-else>در حال کپی کردن پست سازمانی در شرکت تابعه...</button>
    </div>
  </div>
  <div dir="rtl" class="modal__error slide-top" style="z-index: 999999999999999" v-show="submitCloneProcessModal">
    <div>
      <p>اطلاعیه</p>
      <p @click="submitCloneProcessModal=!submitCloneProcessModal">❌</p>
    </div>
    <div>
      <p style="background-color:#fff; padding: 1vw; text-align: right; border-radius: 1vw;">آیا میخواهید فرآیند ها در
        شرکت تابعه ایجاد شود؟</p>
      <button v-if="!is_load" @click="submitCloneProcess">تایید</button>
      <button style="width: 28vw !important;" disabled v-else>در حال کپی کردن فرآیند ها در شرکت تابعه...</button>
    </div>
  </div>
  <div dir="rtl" class="modal__error slide-top" style="z-index: 999999999999999" v-show="submitCloneTaskModal">
    <div>
      <p>اطلاعیه</p>
      <p @click="submitCloneTaskModal=!submitCloneTaskModal">❌</p>
    </div>
    <div>
      <p style="background-color:#fff; padding: 1vw; text-align: right; border-radius: 1vw;">آیا میخواهید فعالیت ها در
        شرکت تابعه ایجاد شود؟</p>
      <button v-if="!is_load" @click="submitCloneTask">تایید</button>
      <button style="width: 28vw !important;" disabled v-else>در حال کپی کردن فعالیت ها در شرکت تابعه...</button>
    </div>
  </div>

</template>

<script>
import Splash from "@/components/Splash/Splash";
import Sidebar from "@/components/Sidebar/Sidebar";
import cookies from "vue-cookies";
import router from "@/router";
import {useToast} from "vue-toastification";
import Vue3PersianDatetimePicker from 'vue3-persian-datetime-picker'

const toast = useToast();

export default {
  name: "ListUser",
  components: {Sidebar, Splash, Vue3PersianDatetimePicker},
  data() {
    return {
      all_users: [],
      searchUser: '',
      addNew: false,
      editModal: false,
      deleteModal: false,
      id: '',
      phone: '',
      password: '',
      username: '',
      fullname: '',
      company_name: '',
      personalCode: '',
      nationalCode: '',
      copy_id: '',
      uni_dredge: '',
      work_history: '',
      course_management: '',
      intro_date: '',
      intro_location: '',
      intro_certificate: '',
      supplementary_date: '',
      supplementary_location: '',
      supplementary_certificate: '',
      first_name: '',
      last_name: '',
      is_load: false,
      is_load_submit: false,
      submitCloneOrganModal: false,
      submitCloneProcessModal: false,
      submitCloneTaskModal: false,
      cLists: [],
    }
  },
  methods: {
    check_dot(id) {
      for (let i = 0; i < this.cLists.length; i++) {
        if (this.cLists[i].company_id === id) {
          return true;
        }
      }
      return false; // اگر هیچ موردی پیدا نشد، false برگردانده می‌شود
    },

    check_dot_success(id) {
      for (let i = 0; i < this.cLists.length; i++) {
        if (this.cLists[i].company_id === id) {
          if(this.cLists[i].approver === 1){
           return true;
          }else{
            return false;
          }
          
        }
      }
      return false; // اگر هیچ موردی پیدا نشد، false برگردانده می‌شود
    },

    submitCloneTask() {
      this.is_load = true
      fetch(`${this.base_url}/user/clone_task_process/${this.copy_id}`, {
        method: 'POST',
        headers: {
          "Authorization": `Bearer ${this.$cookies.get('token')}`,
          'Content-type': 'application/json; charset=UTF-8',

        },
        body: JSON.stringify({
          'type': 'next',
        })
      })
          .then(response => response.json())
          .then((response) => {
            if (response.error) {
              toast.error(response.error)
              this.is_load = false
              return
            }
            if (response.message) {
              this.submitCloneTaskModal = false
              toast.success(response.message)
              this.is_load = false
              this.fetchItems()


            }

          }).catch((err) => {
      })
    },
    submitCloneTaskMethod(id) {
      this.copy_id = id
      this.submitCloneTaskModal = true
    },
    submitCloneProcess() {
      this.is_load = true
      fetch(`${this.base_url}/user/clone_process/${this.copy_id}`, {
        method: 'POST',
        headers: {
          "Authorization": `Bearer ${this.$cookies.get('token')}`,
          'Content-type': 'application/json; charset=UTF-8',

        },
        body: JSON.stringify({
          'type': 'next',
        })
      })
          .then(response => response.json())
          .then((response) => {
            if (response.error) {
              toast.error(response.error)
              this.is_load = false
              return
            }
            if (response.message) {
              this.submitCloneProcessModal = false
              toast.success(response.message)
              this.is_load = false
              this.fetchItems()
            }

          }).catch((err) => {
      })
    },
    submitCloneProcessMethod(id) {
      this.copy_id = id
      this.submitCloneProcessModal = true
    },
    submitCloneOrganMethod(id) {
      this.copy_id = id
      this.submitCloneOrganModal = true
    },
    submitCloneOrgan() {
      this.is_load = true
      fetch(`${this.base_url}/user/clone_organ/${this.copy_id}`, {
        method: 'POST',
        headers: {
          "Authorization": `Bearer ${this.$cookies.get('token')}`,
          'Content-type': 'application/json; charset=UTF-8',

        },
        body: JSON.stringify({
          'type': 'next',
        })
      })
          .then(response => response.json())
          .then((response) => {
            if (response.error) {
              toast.error(response.error)
              this.is_load = false
              return
            }
            if (response.message) {
              this.submitCloneOrganModal = false
              toast.success(response.message)
              this.is_load = false
              this.fetchItems()

            }

          }).catch((err) => {
      })

    },
    resetAll() {
      this.company_name = ''
      this.username = ''
      this.fullname = ''
      this.phone = ''
      this.personalCode = ''
      this.copy_id = ''
      const fileInput = document.getElementById("file");
      fileInput.value = ''
      this.nationalCode = ''
      this.uni_dredge = ''
      this.work_history = ''
      this.course_management = ''
      this.intro_date = ''
      this.intro_location = ''
      this.intro_certificate = ''
      this.supplementary_date = ''
      this.supplementary_location = ''
      this.supplementary_certificate = ''
      this.first_name = ''
      this.last_name = ''

    },
    edit(id) {
      this.resetAll()
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(`${this.base_url}/user/edit_company/${id}`, requestOptions)
          .then(response => response.json())
          .then(result => {
            this.editModal = true
            this.id = id
            const item = result['item']
            if (item) {
              this.nationalCode = item.user.national_code
              this.company_name = item.name
              this.username = item.user.username
              this.first_name = item.user.firstname
              this.last_name = item.user.lastname
              this.phone = item.user.phone
              this.personalCode = item.user.personal_code
              this.course_management = item.user['course_management']
              this.supplementary_date = item.user['supplementary_date']
              this.supplementary_location = item.user['supplementary_location']
              this.supplementary_certificate = item.user['supplementary_certificate']
              this.intro_date = item.user['intro_date']
              this.intro_location = item.user['intro_location']
              this.intro_certificate = item.user['intro_certificate']
              this.uni_dredge = item.user['edu_level'] !== 'null' ? item.user['edu_level'] : ''
              this.work_history = item.user['work_history_time'] !== 'null' ? item.user['work_history_time'] : ''
            }

          })
          .catch();
    },
    deleteItem(id) {
      this.id = id
      this.deleteModal = true
    },

    deleteItemForm(id) {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(`${this.base_url}/user/delete_company/${id}`, requestOptions)
          .then(response => response.json())
          .then(result => {
            if (result.error) {
              this.Error = true
              this.ErrorM = result.error
              toast.error(this.ErrorM)
            }
            this.deleteModal = false
            this.fetchItems()

          })
          .catch();

    },

    store() {
      /*company_name
      fullname
      file
      username
      nationalCode*/
      if (!this.company_name) {
        toast.error('نام شرکت اجباری است')
        return
      } else if (!this.first_name) {
        toast.error('نام  رئیس کمیته اجباری است')
        return
      } else if (!this.last_name) {
        toast.error(' نام خانوادگی رئیس کمیته اجباری است')
        return
      }  else if (!this.personalCode) {
        toast.error('کد پرسنلی اجباری است')
        return
      } else if (!this.nationalCode) {
        toast.error('کدملی اجباری است')
        return
      }
      const fileInput = document.getElementById("file");
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      formdata.append('name', this.company_name)
      formdata.append('first_name', this.first_name)
      formdata.append('last_name', this.last_name)
      formdata.append('phone', this.phone)
      formdata.append('personal_code', this.personalCode)
      formdata.append('copy_id', this.copy_id)
      formdata.append('national_code', this.nationalCode)
      formdata.append('edu_level', this.uni_dredge)
      formdata.append('work_history_time', this.work_history)
      formdata.append('course_management', this.course_management)
      formdata.append('intro_date', this.intro_date)
      formdata.append('intro_location', this.intro_location)
      formdata.append('intro_certificate', this.intro_certificate)
      formdata.append('supplementary_date', this.supplementary_date)
      formdata.append('supplementary_location', this.supplementary_location)
      formdata.append('supplementary_certificate', this.supplementary_certificate)
      formdata.append('file', fileInput.files[0]);

      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/user/new`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              toast.error(response.error.replace('s', ''))
              return;
            }
            toast.success(response.message)
            this.fetchItems()
            this.addNew = false
            this.resetAll()
            this.nationalCode = ''
            fileInput.value = ''


          })
          .catch();
    },
    update() {
      if (!this.company_name) {
        toast.error('نام شرکت اجباری است')
        return
      } else if (!this.first_name) {
        toast.error('نام  رئیس کمیته اجباری است')
        return
      } else if (!this.last_name) {
        toast.error(' نام خانوادگی رئیس کمیته اجباری است')
        return
      } else if (!this.username) {
        toast.error('نام کاربری اجباری است')
        return
      }
      const fileInput = document.getElementById("file");

      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      formdata.append('name', this.company_name)
      formdata.append('first_name', this.first_name)
      formdata.append('last_name', this.last_name)
      formdata.append('phone', this.phone)
      formdata.append('personal_code', this.personalCode)
      formdata.append('national_code', this.nationalCode)
      formdata.append('file', fileInput.files[0]);
      formdata.append('level_edu', this.uni_dredge)
      formdata.append('work_history_time', this.work_history)
      formdata.append('course_management', this.course_management)
      formdata.append('intro_date', this.intro_date)
      formdata.append('intro_location', this.intro_location)
      formdata.append('intro_certificate', this.intro_certificate)
      formdata.append('supplementary_date', this.supplementary_date)
      formdata.append('supplementary_location', this.supplementary_location)
      formdata.append('supplementary_certificate', this.supplementary_certificate)

      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/user/update_company/${this.id}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              toast.error(response.error)
              return
            }
            toast.success(response.message)
            this.fetchItems()
            this.editModal = false
            this.resetAll()


          })
          .catch();
    },
    addNewMethod() {
      this.resetAll()
      this.addNew = !this.addNew
    },

    fetchItems() {
      this.all_users.length = 0
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(`${this.base_url}/user/all_for_mother`, requestOptions)
          .then(response => response.json())
          .then(result => {

            if (result) {
              if (result['users'].length !== 0) {
                result['users'].forEach(item => {
                  this.all_users.push(item)

                })

              }
              if (result.complate1) {
                if (this.$router.options.history.state.back === '/Financial_management_and_productivity/Determining_the_mission') {
                  this.cLists = [...result.complate1]
                }

              }
              if (result.complate2) {
                if (this.$router.options.history.state.back === '/problem_analysis/Problem_identification') {

                  this.cLists = [...result.complate2]
                }

              }
              if (result.complate3) {
                if (this.$router.options.history.state.back === '/problem_analysis/Prioritizing_issue') {

                  this.cLists = [...result.complate3]
                }

              }
              if (result.complate4) {
                if (this.$router.options.history.state.back === '/problem_analysis/The_root_causes_of_the_problem') {

                  this.cLists = [...result.complate4]
                }

              }
              if (result.complate5) {
                if (this.$router.options.history.state.back === '/problem_analysis/Definition_of_basic_measures') {
                  this.cLists = [...result.complate5]

                }

              }

              if (result.complate7) {
                if (this.$router.options.history.state.back === '/problem_analysis/device_monitoring_and_care') {
                  this.cLists = [...result.complate7]
                }
              }
              if (result.complate8) {
                if (this.$router.options.history.state.back === '/executive_elements') {
                  this.cLists = [...result.complate8]
                }
              }
            }

          })
          .catch();
    },

    checkIsMother() {
      if (!this.is_mother) {
        router.push('/')
      }


    }
  },
  mounted() {
    this.checkIsMother()
    this.fetchItems()
  },
  computed: {
    filteredItems() {
      return this.all_users.filter(item => {
        return (
            item['name'].includes(this.searchUser)
        );
      });
    },
    isBackToUserList() {
      return this.$router.options.history.state.back === '/pishkhan/list/user';
    }
  }
}
</script>

<style scoped lang="scss">
label {
  width: 100%;
  text-align: right;
}


p, label {
  font-size: 1vw !important;
}

input[type=checkbox] {
  width: 1vw;
  height: 1vw;
  border-radius: .5vw;
  border: .2vw solid #eee;
}

.text-end {
  font-weight: bold;
}

.change_div {
  background: #fff;
  width: 20vw;
  padding: 1vw;
  margin-left: 5vw;
  border-radius: 1vw;
}
</style>